import { createSlice } from "@reduxjs/toolkit";

export const resultSlice = createSlice({
    name: 'Results',
    initialState: {
        purpose: null,
        vision: null,
        values: null,
        positioning: null,
        look: null,
        tone: null,
        brand: null,
        competition: null,
        trends: null,
        content: null
    },
    reducers: {
        setResults(state, action) {
            state.purpose = action.payload.purpose;
            state.vision = action.payload.vision;
            state.values = action.payload.values;
            state.positioning = action.payload.positioning;
            state.look = action.payload.look;
            state.tone = action.payload.tone;
            state.brand = action.payload.brand;
            state.competition = action.payload.competition;
            state.trends = action.payload.trends;
            state.content = action.payload.content
        }
    }
})

export const { setResults } = resultSlice.actions;

export default resultSlice.reducer;